import styled from 'styled-components';

import {greys} from '../../../../libs/shared/ui/src/styles/colorStyles';
import {fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {MOBILE_BREAKPOINT} from './configurableLayer';

/*
 * Style.
 */

export const StyledHeader = styled.h1`
  color: ${greys.shade80};
  font-size: 24px;
  font-weight: ${fontWeights.semibold};

  @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    font-weight: ${fontWeights.bold};
  }
`;

/*
 * Component.
 */

export const Header = StyledHeader;
